import { Typography } from "@mui/material";
import React from "react";

export interface FormTitleProps {
  title: string;
  fontSize?: string;
  marginBottom?: number;
  color?: string;
  fontWeight?: string;
  textAlignment?: string;
}

const FormTitle = ({
  title,
  fontSize,
  marginBottom,
  color,
  fontWeight,
  textAlignment,
}: FormTitleProps) => {
  return (
    <Typography
      sx={{
        fontWeight: fontWeight || "700",
        fontSize: fontSize || "16px",
        marginBottom: marginBottom || 2,
        color: color || "#000000",
        textAlign: textAlignment || "",
      }}
    >
      {title}
    </Typography>
  );
};

export default React.memo(FormTitle);
